import {
  Button as PrimitiveButton,
  type ButtonProps as PrimitiveButtonProps,
} from "../ui/primitives/button";

/**
 * @deprecated Import `Button` from `src/components/ui` instead.
 * Legacy wrapper removal is deferred by `UI-MIG-LEGACY-001`.
 */
export type ButtonProps = PrimitiveButtonProps;

/**
 * @deprecated Import `Button` from `src/components/ui` instead.
 * Legacy wrapper removal is deferred by `UI-MIG-LEGACY-001`.
 */
export function Button(props: ButtonProps) {
  return <PrimitiveButton {...props} />;
}
